/* eslint-disable import/prefer-default-export */
export const LEADERBOARD_TICKET_PRICE = 500000
export const SKIP_REGISTRATION_FLOW = true
